export default __webpack_public_path__ + "static/media/Avenir-Light.ba8dbe4f.ttf";